import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from './icon';
const Loading = (props) => {
    const { children, className = '', height = 48, light = false, type = '', width = 48, ...rest } = props;
    const containerClasses = [
        'loading',
        type === 'page' ? 'loading-page' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const spinnerClasses = [
        'loading-spinner',
        light ? 'loading-spinner-light' : '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: containerClasses, "data-testid": rest['data-testid'], children: [_jsx("span", { className: spinnerClasses, children: _jsx(Icon, { height: height, name: "spin6", width: width }) }), children] }));
};
export default Loading;
//# sourceMappingURL=loading.js.map